//----------------
// change payload
//----------------
export default function changePayload(parm) {
  // console.log("---------------------");
  // console.log("IN changePayload");
  // console.log("parm.type = " + parm.type);
  let p = parm.payload
  //-------------------
  // check change type
  //-------------------
  switch (parm.type) {
    //--------
    // status
    //--------
    case 'status':
      if (p.status == 'Inactive') {
        p.sr_roll = 0
        p.sr_adj = 0
        p.roll_off = 0
        p.seq = 0
        p.rank = 0
        p.surprised = false
        //
        if (p.sub_status == 'Dead') {
          p.bleeding = 0
          p.fatigue = 'Debilitated'
        }
      } else if (parm.cur_sub_status && parm.cur_sub_status == 'Dead') {
        p.fatigue = 'Fresh'
      }
      break
    //------------
    // visibility
    //------------
    case 'visibility':
      break
    //---------
    // fatigue
    //---------
    case 'fatigue':
      break
    //----------
    // bleeding
    //----------
    case 'bleeding':
      break
    default:
  }
  return p
}
